<template>
    <svg
        v-if="height && width"
        :class="classes"
        :width="width"
        :height="height"
        xmlns="http://www.w3.org/2000/svg"
    >
        <use :xlink:href="`#${icon}`"></use>
    </svg>
    <svg v-else :class="classes" xmlns="http://www.w3.org/2000/svg">
        <use :xlink:href="`#${icon}`"></use>
    </svg>
</template>

<script>
export default {
    name: "SvgIcon",

    props: {
        icon: {
            type: String
        },
        classes: {
            type: String,
            default: ""
        },
        width: {
            type: String,
            default: ""
        },
        height: {
            type: String,
            default: ""
        }
    }
};
</script>
